export default __webpack_public_path__ + "static/Payment-Integration-c2d4911b0d517e47b5fd0fb60168a7c4.webp";